export enum ItemType {
  INSTRUMENT = 'Instrument',
  REAGENT = 'Reagent/Consumable',
}
